/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function deskTocMobileHeaderBottom() {
  var header = document.querySelector('.header');
  return header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
}

function deskTocMobileInit($toc, $content) {
  var $title = $toc.find('.table-of-content-mobile-title');
  var $list = $toc.find('.table-of-content-mobile__list');
  var visible = null;
  var ticking = false;

  function deskTocMobileGetOffset() {
    return deskTocMobileHeaderBottom() + ($title.outerHeight() || 0) + 20;
  }

  function deskTocMobileClose() {
    $toc.removeClass('active');
    $title.attr('aria-expanded', 'false');
    $list.stop(true).slideUp(300);
  }

  function deskTocMobileToggle() {
    if ($toc.hasClass('active')) {
      deskTocMobileClose();
    } else {
      $toc.addClass('active');
      $title.attr('aria-expanded', 'true');
      $list.stop(true).slideDown(300);
    }
  }

  function deskTocMobileKeydown(e) {
    if (e.key === 'Escape' && $toc.hasClass('active')) {
      deskTocMobileClose();
      $title.trigger('focus');
    }
  }

  function deskTocMobileUpdate() {
    ticking = false;
    var headerBottom = deskTocMobileHeaderBottom();
    var contentRect = $content[0].getBoundingClientRect();
    var shouldShow = contentRect.top <= headerBottom && contentRect.bottom > headerBottom;
    $toc.css('top', headerBottom + 'px');
    if (shouldShow === visible) return;
    visible = shouldShow;
    if (shouldShow) {
      $toc.stop(true).fadeIn(200);
    } else {
      $toc.stop(true).fadeOut(200);
      deskTocMobileClose();
    }
  }

  function deskTocMobileRequestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(deskTocMobileUpdate);
  }

  if ($toc.length && $content.length && !$toc.attr('data-toc-init')) {
    $toc.attr('data-toc-init', '');
    $title.on('click', deskTocMobileToggle);
    $list.on('click', 'li', deskTocMobileClose);
    $(document).on('keydown', deskTocMobileKeydown);
    $(window).on('scroll resize', deskTocMobileRequestUpdate);
    deskTocMobileUpdate();
  }

  return { getOffset: deskTocMobileGetOffset };
}
